import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { debounce } from 'lodash';
import Carousel from '../../utility/Carousel';
import Loading from '../../utility/Loading';
import GenericCareerCard from '../../utility/GenericCareerCard';

const numberOfCardsInGroupDesktop = 5;
const numberOfCardsInGroupTablet = 3;

const getId = ({ isMobile, isTablet }) => {
  if (!isMobile && !isTablet) return 'dashboard-top-25-careers-desktop';
  if (!isMobile && isTablet) return 'dashboard-top-25-careers-tablet';
  return 'dashboard-top-25-careers-mobile';
};

const getOverRideStyles = ({ isMobile, isTablet }) => {
  if (!isMobile && !isTablet) return 'top-25-carousel-desktop';
  if (!isMobile && isTablet) return 'top-25-carousel-tablet';
  return 'top-25-carousel-mobile';
};

const getNumDots = ({ isMobile }, careerList) => {
  if (!isMobile) return Math.floor(careerList.length);
};

const AnnotatedCareerCard = ({
  parent,
  career,
  // eslint-disable-next-line no-shadow
  careerCardSubText,
  // eslint-disable-next-line no-shadow
  tenant,
  // eslint-disable-next-line no-shadow
  location,
  userProfileFavorites,
}) => {
  return (
    <GenericCareerCard
      key={career.id}
      parent={parent}
      img={
        career.image ||
        career.img ||
        career.categoryImageVariant ||
        career.categoryImageUrl1
      }
      career={career}
      overRideStyles="top-25-carousel-career-card-middle"
      subText={careerCardSubText}
      subTextTriggersModal
      subTextColor={tenant.primary}
      infoIcon
      location={location}
      favorite
      userProfileFavorites={userProfileFavorites}
      tenant={tenant}
      alert={false}
    />
  );
};

function CareerCarousel(props) {
  const { tenant, location, careerCardSubText, careerList, parent } = {
    ...props,
  };

  const [carouselMedia, setCarouselMedia] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 800 && window.innerWidth < 1200
  );

  const getTabletAndDesktopCarouselMedia = (groupSize) => {
    const groups = [];
    let currentGroup = {
      key: 'media-group-0',
      children: [],
    };
    careerList.forEach((career) => {
      if (currentGroup.children.length < groupSize) {
        currentGroup.children.push(
          <AnnotatedCareerCard
            parent={parent}
            key={career.id}
            career={career}
            tenant={tenant}
            location={location}
            careerCardSubText={careerCardSubText}
            userProfileFavorites={props.userProfileFavorites}
          />
        );
      }
      if (currentGroup.children.length === groupSize) {
        groups.push(currentGroup);
        currentGroup = {
          key: `media-group-${groups.length}`,
          children: [],
        };
      }
    });
    if (currentGroup.children.length) {
      groups.push(currentGroup);
    }
    setCarouselMedia(groups);
  };

  const getMobileCarouselMedia = () => {
    const groups = [];
    let prevIndex = careerList.length - 1,
      nextIndex = 1;
    careerList.forEach((career, index) => {
      if (index === 1) prevIndex = 0;
      if (index === careerList.length - 1) nextIndex = 0;
      groups.push({
        key: `mobile-media-group-${index}`,
        children: [
          <div
            className="top-25-carousel-mobile-group"
            // eslint-disable-next-line react/no-array-index-key
            key={`div-mobile-group-${index}`}
          >
            <AnnotatedCareerCard
              key={`${careerList[prevIndex].id}_prev`}
              career={careerList[prevIndex]}
              tenant={tenant}
              location={location}
              careerCardSubText={careerCardSubText}
              userProfileFavorites={props.userProfileFavorites}
            />

            <AnnotatedCareerCard
              key={`${career.id}_middle`}
              career={career}
              tenant={tenant}
              location={location}
              careerCardSubText={careerCardSubText}
              userProfileFavorites={props.userProfileFavorites}
            />
            <AnnotatedCareerCard
              key={`${careerList[nextIndex].id}_next`}
              career={careerList[nextIndex]}
              tenant={tenant}
              location={location}
              careerCardSubText={careerCardSubText}
              userProfileFavorites={props.userProfileFavorites}
            />
          </div>,
        ],
      });
      ++prevIndex;
      ++nextIndex;
    });
    setCarouselMedia(groups);
  };

  useEffect(() => {
    let _isMounted = true;
    const onWindowResize = debounce(() => {
      if (_isMounted) {
        if (window.innerWidth >= 1200) {
          getTabletAndDesktopCarouselMedia(numberOfCardsInGroupDesktop);
        } else if (window.innerWidth >= 800 && window.innerWidth < 1200) {
          getTabletAndDesktopCarouselMedia(numberOfCardsInGroupTablet);
        } else if (window.innerWidth < 800) {
          getMobileCarouselMedia();
        }
        setIsMobile(window.innerWidth < 800);
        setIsTablet(window.innerWidth >= 800 && window.innerWidth < 1200);
      }
    }, 100);
    window.addEventListener('resize', onWindowResize);
    onWindowResize();
    return () => {
      _isMounted = false;
      window.removeEventListener('resize', onWindowResize);
    };
  }, [careerList]);

  const sizeInfo = { isMobile, isTablet };

  return (
    <div id={getId(sizeInfo)}>
      {carouselMedia.length > 0 ? (
        <Carousel
          numTiles={props.careerList.length}
          parent={props.parent}
          overRideStyles={getOverRideStyles(sizeInfo)}
          carouselMedia={carouselMedia}
          isMobile={isMobile}
          isTablet={isTablet}
          tenant={props.tenant}
          numDots={getNumDots(sizeInfo, carouselMedia)}
          showDots={!isMobile}
        />
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default withRouter(CareerCarousel);
